import script from "./WebBannersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WebBannersPage.vue?vue&type=script&setup=true&lang=js"

import "./WebBannersPage.vue?vue&type=style&index=0&id=e27ccd5a&lang=css"

const __exports__ = script;

export default __exports__